import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  LepValue,
  OpportunityDetailsNavModel,
} from '../../../common/models/opportunity-details.model';
import { SubmissionService } from '../../../http/intake/submission.service';
import { Subject, takeUntil } from 'rxjs';
import { AccordionOptions } from './service-delivery/service-delivery-settings';
import { lepDataValue } from '../opportunity-details-settings';
import {
  configurationType,
  ParsedRules,
  PermissionsObj,
} from '../../../common/models/common-models';
import { BrowserTabConstant } from '../../../common/constants/browser-tab-constant';
import { EclipseHeaderService } from '../../../http/eclipse-header.service';
import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { PROCEED_TO_DOCUMENT_SUBMISSION_BUTTON_OPTIONS } from '../opportunity-details.helper';
import { IntakeConstant } from '../../constants/intake.constant';
import { latestOpportunityDetails } from '../../../common/models/latestOpportunityDetails';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { commonSectionForSingleCoCheck } from '../../common/intake.util';
@Component({
  selector: 'app-oportunity-detail-right-panel',
  templateUrl: './oportunity-detail-right-panel.component.html',
  styleUrl: './oportunity-detail-right-panel.component.less',
})
export class OportunityDetailRightPanelComponent implements OnInit, OnDestroy {
  @Input() opportunityNumber: string = '';
  @Input() tabTitle: string | null = '';
  @Input() submissionDetails: OpportunityDetailsNavModel[] = [];
  @Input() permissionObj: PermissionsObj = {} as PermissionsObj;
  @Input() isOverAllRequired!: () => boolean;
  @Input() setActiveIndex!: (index: number) => void;

  accordionOptions = AccordionOptions;
  unsubscriber$: Subject<void> = new Subject<void>();
  opportunityData: any[] = [];
  lepValue: LepValue = lepDataValue;
  @Output() lepValueChange: EventEmitter<LepValue> =
    new EventEmitter<LepValue>();
  configLabels: configurationType[] = [];
  proceedToDocumentSubmissionButtonOptions: ButtonOptions =
    PROCEED_TO_DOCUMENT_SUBMISSION_BUTTON_OPTIONS;
  proceedToDocumentSubmissionLabel: string =
    IntakeConstant.PROCEED_TO_DOCUMENT_SUBMISSION_BUTTON_LABEL;
  _EMPTY: string = IntakeConstant.EMPTY_SPACE;
  latestSubmissionId!: number | null;
  isComplexitysectionOpen: boolean = true;
  complexityLabel:string = IntakeConstant.EMPTY_SPACE;

  constructor(
    private readonly submissionService: SubmissionService,
    private readonly headerService: EclipseHeaderService
  ) {}

  ngOnInit(): void {
    document.title = BrowserTabConstant.Browser_TabName_Opportunity;
    this.getServiceData();
    this.getLabelConfiguration();
    this.getLatestSubmissionDetail();
    this.isComplexitysectionOpen =
    this.submissionDetails.some((detail) => detail.submissionTypeId !== 5 /*Other*/) &&
    !commonSectionForSingleCoCheck(this.submissionDetails);
  }

  ngAfterViewInit(): void {
    this.scrollToTop();
  }

  getServiceData(): void {
    this.submissionService
      .getDeliveryServiceTable(this.opportunityNumber)
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (data: any) => {
          this.opportunityData = data;
        },
        error: (err) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  shouldShowOfferingQuestions(): boolean {
    if (
      !this.permissionObj[
        'Intake_Opportunity_OfferingServiceQuestions_Visible'
      ] ||
      this.opportunityData?.length === 0
    ) {
      return false;
    }
    const hasInvalidStatus = this.opportunityData.some((submission) =>
      submission.offeringPortfolio?.toLowerCase().includes('cyber')
    );
    const hasValidLocation = this.opportunityData.some((submission) =>
      submission.location?.toLowerCase().includes('united states')
    );
    if (hasInvalidStatus && hasValidLocation) {
      return true;
    }
    this.submissionService.updateComplexQuestionCyberStatus(true);
    return false;
  }

  onLepValueChange(updatedLepValue: LepValue): void {
    this.lepValue = updatedLepValue;
    this.lepValueChange.emit(this.lepValue);
  }

  getLabelConfiguration(): void {
    this.submissionService
      .getIntakeConfigurations()
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (response: configurationType[]) => {
          if (response && response.length > 0) {
            this.configLabels = response;
            this.complexityLabel = this.configLabels.find(
                    (item) =>
                      item.appConfigurationLabelKey ===
                      'Opportunity_Complexity_Guidance'
                  )?.appConfigurationLabelValue || IntakeConstant.EMPTY_SPACE;
          }
        },
        error: (err) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  scrollToTop(): void {
    this.headerService.scrollToTop();
  }

  checkOverallRequirement(): boolean {
    if (!this.permissionObj['Intake_Navigate_Submission_Enable']) {
      return true;
    }
    const result = this.isOverAllRequired();
    return result;
  }

  onProceedToDocumentSubmission(): void {
    const index = this.submissionDetails.findIndex(
      (detail) => detail.submissionId === this.latestSubmissionId
    );
    this.setActiveIndex(index);
  }

  getLatestSubmissionDetail(): void {
    this.submissionService
      .getOpportunitySelected(this.opportunityNumber, true)
      .pipe(takeUntil(this.unsubscriber$))
      .subscribe({
        next: (response: latestOpportunityDetails) => {
          if (response) {
            this.latestSubmissionId = response?.submissionId ?? null;
          }
        },
        error: (err: HttpErrorResponse) => {
          console.error('An error occurred during submission: ', err);
        },
      });
  }

  ngOnDestroy(): void {
    this.unsubscriber$.next();
    this.unsubscriber$.complete();
  }
}
